export const GIVE_RECOGNITION_MODAL_QUERY_PARAM = 'give_recognition';
export const GIVE_RECOGNITION_TEXT_QUERY_PARAM = 'give_recognition_text';

// Rich Bizy Desktop hand-off params (external-browser deep link). Additive and
// backward-compatible with the params above. See BIZY-422.
// Comma-separated usernames, each resolved server-side to a full Recipient.
export const GIVE_RECOGNITION_RECIPIENTS_QUERY_PARAM = 'give_recognition_recipients';
// Numeric points amount (+N).
export const GIVE_RECOGNITION_AMOUNT_QUERY_PARAM = 'give_recognition_amount';
// Comma-separated tags WITHOUT a leading '#'.
export const GIVE_RECOGNITION_HASHTAGS_QUERY_PARAM = 'give_recognition_hashtags';
